import {ActionsEnum} from "@/entity/ActionsEnum";

export var menuItems = [
    {
        action: 'mdi-circle',
        title: 'Genel',
        active: true,
        items: [
            {
                title: 'Kullanıcılar' ,
                route:  '/genel/kullanicilar',
                action: ActionsEnum.Users
            },
            {
                title: 'Yorumlar' ,
                route:  '/genel/comments',
                action: ActionsEnum.Comments
            },
            {
                title: 'Sayfalar' ,
                route:  '/genel/sayfalar',
                action: ActionsEnum.Pages
            },
            {
                title: 'SSS' ,
                route:  '/genel/sss',
                action: ActionsEnum.Pages
            },
            {
                title: 'Programlar' ,
                route:  '/genel/programlar',
                action: ActionsEnum.Pages
            },
        ],
    },
    {
        action: 'mdi-circle',
        title: 'Site Ayarları',
        active: false,
        items: [
            {
                title: 'Genel' ,
                route:  '/ayarlar/siteconfig',
                action: ActionsEnum.Config
            },
            {
                title: 'Slider' ,
                route:  '/ayarlar/slider',
                action: ActionsEnum.Slider
            },
            {
                title: 'Banner' ,
                route:  '/ayarlar/banner',
                action: ActionsEnum.Banner
            },
            {
                title: 'Seo Ayarları' ,
                route:  '/ayarlar/seosettings',
                action: ActionsEnum.Seo
            },
        ],
    }
];